import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=18360b6c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=18360b6c&prod&lang=less&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=18360b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18360b6c",
  null
  
)

export default component.exports